<template>
    <b-container >
        <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
        <b-alert :show = "showDismissibleAlert" dismissible 
            @dismissed="showDismissibleAlert=false"
             
            :variant="variant">
            {{alertText}}
        </b-alert>
        <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row>
                <b-col md="7">
                  <!-- <b-form-radio-group v-model="form.RegistrationType"
                                      size="sm" stacked
                                      name="radiosStacked">
                      <b-form-radio value="0" @change="changeRegType" selected>Resgistration as New Secuirty Guard</b-form-radio>
                      <b-form-radio value="1" @change="changeRegType1">Registration of AFFECTED Secuirty Guards</b-form-radio>
                      <b-form-radio value="2" @change="changeRegType2">Recommanded by registered Principal Employer for Registration and Allotment</b-form-radio>
                      <b-form-radio value="3" @change="changeRegType3">Registration by Court Orders</b-form-radio>
                      <b-form-radio value="4" @change="changeRegType4">Registration on Compassionate Ground</b-form-radio>
                  </b-form-radio-group>    -->
                  <b-form-group id="gsgblist" horizontal  label-size="sm"
                      label="Registration Type <span style='color:red'>*</span>"
                      label-for="inpregtyp">
                      <b-form-select id="inpregtyp" v-model="form.RegistrationType" :options="options" class="mb-3" 
                      size="sm" 
                      @input="setRegType"
                      disabled
                      ></b-form-select>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="gsgblist" horizontal  label-size="sm"
                        label="Board Name <span style='color:red'>*</span>" 
                        label-for="inpsgb" v-if="form.RegistrationType!=0">
                    <b-form-select id="inpsgb"
                            :options="sgbList"
                            value-field="SecurityBoardID"
                            text-field="SecurityBoardName"
                            required size="sm"
                            v-model="form.BoardID"
                            disabled
                            >
                    </b-form-select>    
                  </b-form-group>   
                  <b-form-group id="gsgblist" horizontal  label-size="sm"
                        label="Do You Have Prior Experience? <span style='color:red'>*</span>" 
                        label-for="radioexpr" v-if="form.RegistrationType==0">
                    <b-form-radio-group id="radioexpr" size="sm" v-model="form.PriorExperience" >
                            <b-form-radio value="true">Yes</b-form-radio>
                            <b-form-radio value="false">No</b-form-radio>
                        </b-form-radio-group>    
                  </b-form-group>
                </b-col>
            </b-row>
            <p style="font-size:.875rem" class="mb-2" v-if="form.RegistrationType==3"> <strong>Provide details about deceased Guard</strong></p>
            <b-row v-if="form.RegistrationType==3">
              <b-col md="3">
                <b-form-group id="ingsgcode" horizontal
                        label="Registration Number <span style='color:red'>*</span>" label-size="sm"
                        label-cols="7"
                        label-for="inpsgcode">
                    <b-form-input id="inpsgcode"
                        type="text"
                        v-model="form.DeceasedRegNum"
                        required size="sm"
                        placeholder="Registration Number of the Guard"
                        disabled
                        ></b-form-input>    
                </b-form-group>
              </b-col>
              <b-col md="5">
                <b-form-group id="ingsgcode" horizontal
                        label="Name <span style='color:red'>*</span>" label-size="sm"
                        label-for="inpsgcode" label-cols="2">
                    <b-form-input id="inpsgcode"
                        type="text"
                        v-model="form.DeceasedName"
                        required size="sm"
                        placeholder="Name of the Guard"
                        disabled
                        ></b-form-input>    
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="ingrltn" horizontal 
                        label="Relationship with Guard <span style='color:red'>*</span>" label-size="sm"
                        label-for="ingrltn" label-cols="6">
                    <b-form-select id="ingrltn"
                            :options="relations"
                            required size="sm"
                            v-model="form.DeceasedRelation"
                            disabled
                            >
                    </b-form-select>    
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.RegistrationType==3 && form.DeceasedRelation=='Other'">
              <b-col></b-col>
              <b-col md="5">
                <b-form-group id="ingsgcode" horizontal
                        label="Relationship with Guard <span style='color:red'>*</span>" label-size="sm"
                        label-cols="5" description="If Relation is 'Other', provide details"
                        label-for="inpsgcode">
                    <b-form-input id="inpsgcode"
                        type="text"
                        v-model="form.OtherRelationName"
                        required size="sm"
                        placeholder="Relationship Details"
                        
                        ></b-form-input>    
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.RegistrationType==3">
              <b-col md="6">
              <b-form-group id="exampleInputGroup1" horizontal
                            label="Name of Legal Heir <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput1">
                  <b-input-group>
                      <b-input-group-prepend>
                      <b-form-input type="text" required size="sm" placeholder="First Name" style="width:130px"
                          v-model="form.HeirFirstName" :formatter="format" lazy-formatter
                          disabled
                          ></b-form-input>

                      </b-input-group-prepend>

                      <b-form-input type="text" placeholder="Middle Name" size="sm" required
                          v-model="form.HeirMiddleName" :formatter="format" lazy-formatter style="width:75px"
                          disabled
                          ></b-form-input>

                      <b-input-group-append>
                      <b-form-input type="text" required placeholder="Last Name" size="sm" style="width:130px"
                          v-model="form.HeirLastName" :formatter="format" lazy-formatter
                          disabled
                          ></b-form-input>

                      </b-input-group-append>
                  </b-input-group>    
              </b-form-group>
              </b-col>
            </b-row>
            <p style="font-size:.875rem" class="mb-2" v-if="form.RegistrationType==4"> <strong>Provide details of Court Order</strong></p>
            <b-row v-if="form.RegistrationType==4">
              <b-col md="5">
                <b-form-group id="ingsgcode" horizontal
                        label="Order Number <span style='color:red'>*</span>" label-size="sm"
                        label-cols="3"
                        label-for="inpsgcode">
                    <b-form-input id="inpsgcode"
                        type="text"
                        v-model="form.OrderNum"
                        required size="sm"
                        
                        placeholder="Court Order Number"></b-form-input>    
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group id="ingsgcode" horizontal
                        label="Order Date <span style='color:red'>*</span>" label-size="sm"
                        label-for="inpsgcode" label-cols="4">
                    <!-- <b-form-input id="inpsgcode"
                        type="date"
                        v-model="form.OrderDate"
                        required size="sm"></b-form-input>   -->
                    <date-picker v-model="OrderDate" format="DD-MM-YYYY" lang="en" required size="small" disabled></date-picker>  
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="ingrltn" horizontal
                        label="Court <span style='color:red'>*</span>" label-size="sm"
                        label-for="ingrltn" label-cols="2">
                    <b-form-input id="inpsgcode"
                        type="text"
                        v-model="form.CourtName"
                        required size="sm"
                        disabled
                        placeholder="Name of the Court"></b-form-input>    
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="form.RegistrationType==4">
              <b-col md="5">
                <b-form-group id="ingsgcode" horizontal
                        label="Petition Number <span style='color:red'>*</span>" label-size="sm"
                        label-cols="3"
                        label-for="inpsgcode">
                    <b-form-input id="inpsgcode"
                        type="text"
                        v-model="form.PetitionNum"
                        required size="sm"
                        disabled
                        placeholder="Petition Number"></b-form-input>    
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group id="ingsgcode" horizontal
                        label="Petition Dt.<span style='color:red'>*</span>" label-size="sm"
                        label-for="inpsgcode" label-cols="4">
                    <date-picker v-model="PetitionDate" format="DD-MM-YYYY" lang="en" required size="small" ></date-picker>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="ingrltn" horizontal
                        label="Union<span style='color:red'>*</span>" label-size="sm"
                        label-for="ingrltn" label-cols="2">
                    <b-form-input id="inpsgcode"
                        type="text"
                        v-model="form.UnionName"
                        required size="sm"
                        disabled
                        placeholder="Name of the Union"></b-form-input>    
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="6" sm="12" class="mt-2">
                    <p style="font-size: 17px;color:#2284ab;">Personal Details</p>
                    <p></p>
                    <div  class="pb-5" style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
                    <b-form-group id="exampleInputGroup1" horizontal
                            label="Full Name <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput1">
                        <b-input-group>
                            <b-input-group-prepend>
                            <b-form-input type="text" required size="sm" placeholder="First Name" style="width:130px"
                                v-model="form.FirstName" :formatter="format" lazy-formatter disabled></b-form-input>

                            </b-input-group-prepend>

                            <b-form-input type="text" placeholder="Middle Name" size="sm" required
                                v-model="form.MiddleName" :formatter="format" lazy-formatter style="width:75px" disabled></b-form-input>

                            <b-input-group-append>
                            <b-form-input type="text" required placeholder="Last Name" size="sm" style="width:130px"
                                v-model="form.LastName" :formatter="format" lazy-formatter disabled></b-form-input>

                            </b-input-group-append>
                        </b-input-group>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal
                            label="Gender <span style='color:red'>*</span>" label-size="sm"
                            label-for="radiosg">
                        <b-form-radio-group id="radiosg" size="sm" v-model="form.Gender" >
                            <b-form-radio v-on:change="checkGender(true)" value="true">Male</b-form-radio>
                            <b-form-radio v-on:change="checkGender(false)" value="false">Female</b-form-radio>
                        </b-form-radio-group>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup3" horizontal
                            label="Birth Date <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput3">
                        <!-- <b-form-input id="exampleInput2"
                            type="date"
                            v-model="form.DOB"
                            required size="sm" :state="validateAge"
                            placeholder="Date of Birth"></b-form-input>     -->
                            <date-picker v-model="DOB" :state="validateAge" format="DD-MM-YYYY" lang="en" required size="small" disabled></date-picker>
                    </b-form-group>
                    <b-form-group id="grpAddress" horizontal 
                             label-size="sm" label="Place of Birth">
                        <b-form-input id="exampleInput2"
                            type="text" :formatter="format" lazy-formatter
                            v-model="form.PlaceOfBirth"
                            required size="sm"
                            placeholder="Place of Birth"></b-form-input>
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal
                            label="Email ID" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-input id="exampleInput2"
                            type="email"
                            v-model="form.EmailID"
                            size="sm"
                            placeholder="Valid Email ID"
                            disabled
                            ></b-form-input>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal
                            label="Mobile <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-input id="exampleInput2"
                            type="number" :state="mobileNumber"
                            v-model="form.MobileNo"
                            required size="sm" min="1000000000" max="9999999999"
                            placeholder="10 digit Mobile Number"
                            disabled
                            ></b-form-input>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal
                            label="Landline Number" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-input id="exampleInput2"
                            type="text"
                            v-model="form.LandlineNo"
                            size="sm" :formatter="format" lazy-formatter
                            placeholder="Landline Number"></b-form-input>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal
                            label="Mother's Name <span style='color:red'>*</span>" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-input id="exampleInput2"
                            type="text" :formatter="format" lazy-formatter
                            v-model="form.MotherName"
                            required size="sm"
                            placeholder="Mother's Name"></b-form-input>    
                    </b-form-group>
                    
                    </div>
                </b-col>
                <b-col  md="6" sm="12"  class="mt-2">
                    <p>
                        <span style="font-size: 17px;color:#2284ab;">Other Details</span> 
                    </p>
                    
                    <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;">
                    <b-form-group id="exampleInputGroup1" horizontal label-cols="4"
                            label="Adhar Card No." label-size="sm"
                            label-for="exampleInput1">
                        <b-form-input type="text" :formatter="format" lazy-formatter
                                size="sm" :state="validateAadhar"
                                v-model="form.AdharNo"
                                placeholder="Aadhar Number 12 digit"
                                disabled
                                ></b-form-input>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal label-cols="4"
                            label="Pancard No." label-size="sm"
                            label-for="exampleInput2">
                        <b-form-input type="text" 
                                size="sm" :formatter="format" lazy-formatter
                                v-model="form.PanCardNo" :state="validatePan"
                                placeholder="PAN 10 digit"></b-form-input>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal label-cols="4"
                            label="Married Status" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-radio-group id="radiosM" size="sm" v-model="form.MaritalStatus" name="radioSubComponentM">
                            <b-form-radio value="true">Yes</b-form-radio>
                            <b-form-radio value="false">No</b-form-radio>
                        </b-form-radio-group>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal label-cols="4"
                            label="Nationality" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-radio-group id="radiosN" size="sm" v-model="form.Nationality" name="radioSubComponentN">
                            <b-form-radio value="true">Indian</b-form-radio>
                            <b-form-radio value="false">Nepali</b-form-radio>
                        </b-form-radio-group>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal label-cols="4"
                            label="Maharashtra Domicile" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-radio-group id="radiosD" size="sm" v-model="form.Domiciled" name="radioSubComponentD">
                            <b-form-radio value="true">Yes</b-form-radio>
                            <b-form-radio value="false">No</b-form-radio>
                        </b-form-radio-group>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" size="sm" horizontal label-cols="4"
                            label="Ex-ServiceMan?" label-size="sm"
                            label-for="exampleInput2">
                        <b-form-radio-group id="radiosX" size="sm" v-model="form.ExServiceMan" disabled name="radioSubComponentX">
                            <b-form-radio value="true">Yes</b-form-radio>
                            <b-form-radio value="false">No</b-form-radio>
                        </b-form-radio-group>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal label-cols="4"
                            label="Driving License?" label-size="sm"
                            label-for="radios2">
                        <b-form-radio-group id="radiosL"  size="sm" v-model="form.Driving" name="radioSubComponentL">
                            <b-form-radio value="true">Yes</b-form-radio>
                            <b-form-radio value="false">No</b-form-radio>
                        </b-form-radio-group>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup1" horizontal label-cols="4"
                            label="Mother Toungue" label-size="sm"
                            label-for="exampleInput1">
                        <b-form-input type="text" 
                                size="sm"  :formatter="format" lazy-formatter
                                v-model="form.MotherToung" 
                                placeholder="Mother Toungue"></b-form-input>    
                    </b-form-group>
					          <b-form-group label="Languages Known:" horizontal label-cols="4" label-size="sm">
                        <!-- <b-form-checkbox-group id="checkboxes2" name="languages" v-model="LanguagesKnown"> -->
                          <b-form-checkbox size="sm" v-model="form.Marathi">Marathi</b-form-checkbox>
                          <b-form-checkbox size="sm" v-model="form.Hindi">Hindi</b-form-checkbox>
                          <b-form-checkbox size="sm" v-model="form.English">English</b-form-checkbox>
                          <b-form-checkbox size="sm" v-model="form.Other">Other</b-form-checkbox>
                        <!-- </b-form-checkbox-group> -->
                    </b-form-group>
                    <b-form-group id="iglangOthr" horizontal v-if="form.Other"
                            label="Other Languages" label-size="sm">
                        <b-form-input type="text" 
                                size="sm"  :formatter="format" lazy-formatter
                                v-model="form.OtherLanguages"
                                placeholder="Other Languages"></b-form-input>    
                    </b-form-group>
                     <b-form-group id="exampleInputGroup2" horizontal label-cols="4" v-if="form.Gender == false"
                            label="Is Your Name Change?" label-size="sm"
                            label-for="radios2">
                        <b-form-radio-group id="radiosName"  size="sm" v-model="form.IsNameChanged " name="radioSubComponentName">
                            <b-form-radio value="true">Yes</b-form-radio>
                            <b-form-radio value="false">No</b-form-radio>
                        </b-form-radio-group>    
                    </b-form-group>
                  </div>
                </b-col>
            </b-row>

            
            <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"  class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Employment Exchange Information</p>
                <b-row align-h="center">
                        <b-col md="5" sm="12">
                        <b-form-group id="exampleInputGroup2" horizontal
                            label="Whether registered in Employment Exchange?<span style='color:red'>*</span>" label-size="sm"
                            label-for="radios2" label-cols="8">
                        <b-form-radio-group id="radiosE" v-model="isEmpExchange" name="radioSubComponentE">
                            <b-form-radio value="true">Yes</b-form-radio>
                            <b-form-radio value="false">No</b-form-radio>
                        </b-form-radio-group>    
                    </b-form-group>
                        </b-col>
                </b-row>  
                <b-row align-h="center" v-if="isEmpExchange=='true'">
                        <b-col md="5" sm="12">
                        <b-form-group id="exampleInputGroup2" horizontal
                            label="Employment Exchange Name" label-size="sm"
                            label-for="radios2" label-cols="8">
                        <b-form-input type="text" 
                                size="sm" :formatter="format" lazy-formatter
                                v-model="form.UserEmploymentExchange.EmploymentName"
                                ></b-form-input>   
                    </b-form-group>
                        </b-col>
                </b-row>
                <b-row align-h="center" v-if="isEmpExchange=='true'">
                    <b-col md="5" sm="12">
                        <b-form-group id="exampleInputGroup2" horizontal
                            label="Employment Exchange Registration No." label-size="sm"
                            label-cols="8">
                        <b-form-input type="text" 
                                size="sm" :formatter="format" lazy-formatter
                                v-model="form.UserEmploymentExchange.EmploymentRegNo"
                                ></b-form-input>    
                    </b-form-group>
                    </b-col>
                </b-row>      
            </div>
            
            <div style="padding: 10px;
                            border: 2px solid #c4c6be;
                            border-radius: 15px;"  class="mt-2">
                <p style="font-size: 17px;color:#2284ab;">Caste / Category Details</p>
                <b-row align-h="center">
                    <b-col md="5" sm="12">
                    <b-form-group id="exampleInputGroup2" horizontal  label-size="sm"
                            label="Religion <span style='color:red'>*</span>" label-cols="4"
                            label-for="exampleInput2">
                        <b-form-select id="exampleInput1"
                                :options="religions"
                                value-field="ReligionID"
                                text-field="ReligionName"
                                required size="sm"
                                v-model="form.UserReligionCaste.ReligionID">
                        </b-form-select>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal label-size="sm"
                            label="Category <span style='color:red'>*</span>" label-cols="4" small
                            label-for="exampleInput2">
                        <b-form-select id="exampleInput1"
                                :options="categories"
                                required size="sm"
                                value-field="CategoryID"
                                text-field="CategoryName"
                                v-model="form.UserReligionCaste.CategoryID">
                        </b-form-select>    
                    </b-form-group>
                    <b-form-group id="exampleInputGroup2" horizontal label-size="sm"
                            label="Sub Caste" label-cols="4"
                            label-for="exampleInput2">
                        <b-form-input type="text" 
                                size="sm" :formatter="format" lazy-formatter
                                v-model="form.UserReligionCaste.SubCaste"
                                placeholder="Caste"></b-form-input>
                           
                    </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <b-row class="mt-2" v-if="!form.LockProfile">
                <b-col style="text-align:center">
                  <Spinner size="32" message="Loading..." v-if="isLoading"> </Spinner>
                  <b-alert :show = "showDismissibleAlert" dismissible 
                      @dismissed="showDismissibleAlert=false"
                      
                      :variant="variant">
                      {{alertText}}
                  </b-alert>
                </b-col>
                <b-col style="text-align:right">
                  <b-button type="submit" variant="primary">Submit</b-button>
                  <b-button type="reset" variant="danger">Reset</b-button>
                  <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
                </b-col>
            </b-row>
        </b-form>
        <br/>
    </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
export default {
  name: "PersonalDetails",
  components: { Spinner, DatePicker },
  data() {
    return {
      isAdrsSame: false,
      options: [
        { text: "Marathi", value: "Marathi" },
        { text: "Hindi", value: "Hindi" },
        { text: "English", value: "English" },
        { text: "Other", value: "Other" }
      ],
      DOB: null,
      OrderDate: null,
      PetitionDate: null,
      form: {
        LoginID: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        Gender: true,
        DOB: "",
        Age: 0,
        PlaceOfBirth: "",
        MobileNo: "",
        EmailID: "",
        LandlineNo: "",
        MotherName: "",
        AdharNo: "",
        PanCardNo: "",
        MaritalStatus: false,
        Nationality: true,
        Domiciled: true,
        ExServiceMan: false,
        Driving: false,
        IsNameChanged : false,
        MotherToung: "Marathi",
        Marathi: true,
        Hindi: false,
        English: false,
        Other: false,
        OtherLanguages: "",
        BoardID: "",
        UserReligionCaste: {
          ReligionID: "",
          CategoryID: "",
          SubCaste: ""
        },
        UserEmploymentExchange: {
          EmploymentName: "",
          EmploymentRegNo: ""
        },
        RegistrationType: 0,
        DeceasedRelation: "",
        DeceasedRegNum: "",
        DeceasedName: "",
        PetitionNum: "",
        OrderNum: "",
        OrderDate: null,
        PetitionDate: "",
        UnionName: "",
        OtherRelationName: "",
        PriorExperience: false
      },
      isEmpExchange: false,
      religions: [],
      categories: [],
      sgbList: [],
      show: true,
      alertText: "",
      showDismissibleAlert: false,
      variant: "success",
      isLoading: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      saved: false,
      options: [
        { value: 0, text: "Resgistration as New Secuirty Guard" },
        { value: 1, text: "Registration of AFFECTED Secuirty Guards" },
        {
          value: 2,
          text:
            "Recommanded by registered Principal Employer for Registration and Allotment"
        },
        { value: 3, text: "Registration on Compassionate Ground" },
        { value: 4, text: "Registration by Court Orders" }
      ],
      relations: [
        "Son",
        "Daughter",
        "Wife",
        "Husband",
        "Brother",
        "Sister",
        "Other"
      ]
    };
  },
  computed: {
    mobileNumber() {
      if (this.form.MobileNo != null) {
        var phoneno = /^\d{10}$/;
        if (this.form.MobileNo.match(phoneno)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validateAadhar() {
      if (this.form.AdharNo == null) {
        return true;
      }

      if (this.form.AdharNo.length == 0) {
        return true;
      } else if (this.form.AdharNo != null) {
        var adharformat = /^\d{12}$/;
        if (this.form.AdharNo.match(adharformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    validatePan() {
      if (this.form.PanCardNo == null) {
        return true;
      }

      if (this.form.PanCardNo.length == 0) {
        return true;
      } else if (this.form.PanCardNo != null) {
        var panformat = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        if (this.form.PanCardNo.match(panformat)) {
          return true;
        } else {
          return false;
        }
        //PAN 5th letter should match Surname's first l
        //Kuldip Removed this condition as Married woman face problem
        // if (
        //   this.form.PanCardNo.match(panformat) &&
        //   this.form.PanCardNo.charAt(4).toLowerCase() ==
        //     this.form.LastName.charAt(0).toLowerCase()
        // ) {
        //   return true;
        // } else {
        //   return false;
        // }
        //return true;
      } else {
        return false;
      }
    },
    validateAge() {
      // console.log('1');
      //let age = this.calculateAge(this.form.DOB);
      let age = this.calculateAge(this.DOB);
      if (age < 18) {
        return false;
      }

      if (this.form.RegistrationType > 0 && age < 58) {
        // console.log('2');
        return true;
      }

      if (
        this.form.RegistrationType == 0 &&
        (this.form.PriorExperience == "true" || this.form.PriorExperience == true) &&
        age < 58
      ) {
        // console.log('2');
        return true;
      }
      // console.log(this.form.ExServiceMan);
      if (
        (this.form.ExServiceMan == "true" || this.form.ExServiceMan == true) &&
        age <= 45
      ) {
        // console.log("3");
        return true;
      }

      if (
        this.form.UserReligionCaste.CategoryID.toLowerCase() ==
          "d25679fb-92ea-434d-a0f8-65b3290c7a8b" &&
        age <= 33
      ) {
        // console.log('4');
        return true;
      } else if (
        this.form.UserReligionCaste.CategoryID.toLowerCase() ==
          "d25679fb-92ea-434d-a0f8-65b3290c7a8b" &&
        age > 33
      ) {
        return false;
      } else if (
        this.form.UserReligionCaste.CategoryID.toLowerCase() !=
          "d25679fb-92ea-434d-a0f8-65b3290c7a8b" &&
        age <= 38
      ) {
        // console.log('5');
        return true;
      } else if (
        this.form.UserReligionCaste.CategoryID.toLowerCase() !=
          "d25679fb-92ea-434d-a0f8-65b3290c7a8b" &&
        age > 38
      ) {
        return false;
      }
    }
  },
  methods: {
    checkGender(Gender){
      if (Gender==true) {
        this.form.IsNameChanged = false;
      }
      if (Gender==false) {
        this.form.IsNameChanged = false;
      }
    },
    // showdate(evt){
    //   alert(this.form.DOB);
    // },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    format(value, event) {
      if (value != null) {
        return value.trim();
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    convertDateFormat(inDate) {
      //return indate.split("T")[0];
      let dbDateTime = new Date(inDate);
      let formattedDate =
        dbDateTime.getDate() +
        "-" +
        (dbDateTime.getMonth() + 1) +
        "-" +
        dbDateTime.getFullYear();
      return formattedDate;
    },
    convertDateFormatYMD(inDate) {
      let dbDateTime = new Date(inDate);
      let formattedDate =
        dbDateTime.getFullYear() +
        "-" +
        (dbDateTime.getMonth() + 1) +
        "-" +
        dbDateTime.getDate();
      return formattedDate;
    },
    setRegType() {
      this.$store.dispatch("setRegType", this.form.RegistrationType);
    },
    changeRegType(checked) {
      if (checked) {
        //console.log('emiting')
        this.$store.dispatch("setRegType", 0);
      }
    },
    changeRegType1(checked) {
      if (checked) {
        this.$store.dispatch("setRegType", 1);
        if (this.sgbList.length == 0) {
          this.getSGBList();
        }
      }
    },
    changeRegType2(checked) {
      if (checked) {
        this.$store.dispatch("setRegType", 1);
        if (this.sgbList.length == 0) {
          this.getSGBList();
        }
      }
    },
    getSGBList() {
      this.sgbList = this.$store.getters.getSGBList;
      if (this.sgbList.length == 0) {
        let promise = apis.readSGBoardName();

        promise
          .then(response => {
            if (response.status == 200) {
              let rspns = response.body;
              this.sgbList = response.body;
              this.$store.dispatch("setSGBList", rspns);
            } else {
              this.alertText = "Unable to Load Board List, " + response.body;

              this.variant = "warning";
              this.showDismissibleAlert = true;
            }
          })
          .catch(err => {
            this.alertText = "Unable to Load Board List, " + err.body;
            this.showDismissibleAlert = true;
            this.variant = "danger";
          });
      }
    },
    calculateAge(birthDate) {
      birthDate = new Date(birthDate);
      let incrementDate = new Date(birthDate);
      // console.log(incrementDate);
      let today = new Date();
      let n = 0;
      while (incrementDate < today) {
        n++;
        incrementDate.setYear(incrementDate.getFullYear() + 1);
      }

      return n - 1;

      // let otherDate = new Date();

      // var years = otherDate.getFullYear() - birthDate.getFullYear();
      // var months = years*12

      // if (
      //   otherDate.getMonth() < birthDate.getMonth() ||
      //   (otherDate.getMonth() == birthDate.getMonth() &&
      //     otherDate.getDate() < birthDate.getDate())
      // ) {
      //   years--;
      // }

      // return years;
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      this.showDismissibleAlert = false;
      this.saved = false;
      if (!this.mobileNumber) {
        this.alertText = "Please verify the mobile number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.validateAadhar) {
        this.alertText = "Please verify the Aadhar number";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.validatePan) {
        this.alertText = "Please verify the PAN";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }
      if (!this.validateAge) {
        this.alertText = "Age Criteria not fulfilled";
        this.variant = "warning";
        this.showDismissibleAlert = true;
        this.isLoading = false;
        return;
      }

      this.form.DOB = this.convertDateFormatYMD(this.DOB);
      this.form.OrderDate = this.convertDateFormatYMD(this.OrderDate);
      this.form.PetitionDate = this.convertDateFormatYMD(this.PetitionDate);

      var userinfo = this.$store.getters.loggedUser;
      this.form.LoginID = userinfo.UserId;
      if (this.form.DeceasedRelation != "Other") {
        this.form.OtherRelationName = "";
      }

      //console.log('Form', this.form);
      let promise = apis.saveUserRegistration(this.form);
      this.$store.dispatch("setUserData", this.form);

      if (this.form.PriorExperience == "true" || this.form.PriorExperience == true) {
        this.$store.dispatch("setExperienceFlag", true); //Dsplay the Experience file Upload
      } else {
        this.$store.dispatch("setExperienceFlag", false);
      }

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";

            this.variant = "success";
            this.showDismissibleAlert = true;
            this.saved = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.body;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form = {
        LoginID: "",
        FirstName: "",
        MiddleName: "",
        LastName: "",
        Gender: true,
        DOB: null,
        Age: 0,
        PlaceOfBirth: "",
        MobileNo: "",
        EmailID: "",
        LandlineNo: "",
        MotherName: "",
        AdharNo: "",
        PanCardNo: "",
        MaritalStatus: false,
        Nationality: true,
        Domiciled: true,
        ExServiceMan: false,
        Driving: false,
        IsNameChanged : false,
        MotherToung: "Marathi",
        BoardID: "",
        UserReligionCaste: {
          ReligionID: "",
          CategoryID: "",
          SubCaste: ""
        },
        UserEmploymentExchange: {
          EmploymentName: "",
          EmploymentRegNo: ""
        },
        RegistrationType: 0,
        DeceasedRelation: "",
        DeceasedRegNum: "",
        DeceasedName: "",
        HeirFirstName: "",
        HeirMiddleName: "",
        HeirLastName: "",
        PetitionNum: "",
        OrderNum: "",
        OrderDate: null,
        PetitionDate: "",
        UnionName: "",
        OtherRelationName: "",
        LockProfile: false
      };
      (this.OrderDate = null), (this.PetitionDate = null);
    },
    filterDistricts() {},
    filterTalukas() {}
  },
  mounted() {
    this.getSGBList();

    let promise = apis.getReligion();
    let promiseCat = apis.getCategory();

    promise
      .then(response => {
        //console.log('Reponse' ,response);
        if (response.status == 200) {
          this.religions = response.body;
          //console.log('religion',this.religions)
          this.isLoading = false;
          //this.$router.push("/");
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });

    promiseCat
      .then(response => {
        //console.log('Reponse' ,response);
        if (response.status == 200) {
          this.categories = response.body;
          this.$store.dispatch("setCatList", response.body);
          this.isLoading = false;
          //this.$router.push("/");
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });

    var userinfo = this.$store.getters.loggedUser;
    let promiseU = apis.ReadUserDetail(userinfo.UserId);

    promiseU
      .then(response => {
        if (response.status == 200) {
          this.form = response.body;      
          //this.form.DOB = this.convertDateFormat(response.body.DOB);
          this.DOB = this.form.DOB;
          this.OrderDate = this.form.OrderDate;
          this.PetitionDate = this.form.PetitionDate;

          this.$store.dispatch("setUserData", this.form);
          this.$store.dispatch("setRegType", this.form.RegistrationType);
          this.isLoading = false;
        } else {
          this.alertText = response.body;

          this.variant = "warning";
          this.showDismissibleAlert = true;
        }
      })
      .catch(err => {
        this.alertText = err.body;
        this.showDismissibleAlert = true;
        this.variant = "danger";
      });
  }
};
</script>

<style>
.form-group {
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationDetails/PersonalDetails.vue